export default __webpack_public_path__ + "static/media/latinmotion-logo.f93b2226.png";